import {combineReducers} from 'redux'
import {dataColors} from './query-results'

export default combineReducers({
  dataColors,
})
